import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"

import { ProductInput } from "shared/ui/product-input/ProductInput"

import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

export interface BuildingReferenceProductFilterInputProps {
  options: ProductSelectOption[] | undefined
  disabled?: boolean
}

export const BuildingReferenceProductFilterInput = React.memo(
  ({ options, disabled }: BuildingReferenceProductFilterInputProps) => {
    const { t } = useTranslation()

    const renderValue = useCallback(
      () => (
        <span className="combobox__placeholder">{t("General.Select")}</span>
      ),
      [t]
    )

    return (
      <ProductInput
        name="products"
        options={options}
        disabled={disabled}
        elevated
        className="building-reference-filter__products product-combobox"
        popoverClassName="product-combobox__positioner"
        popupClassName="product-combobox__popup"
        label={t("BuildingReference.Filter.Products")}
        renderValue={renderValue}
      />
    )
  }
)

BuildingReferenceProductFilterInput.displayName =
  "BuildingReferenceProductFilterInput"
